<template>
    <div
        class="container-fluid doubts-container weeducAdminDoubt page-card"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>

        <div v-else>
            <div class="title-container myCoursesWeeduc">
                <div class="title-wrapper">
                    <h3 class="card-title">{{ doubt.title }}</h3>
                    <p class="card-subtitle">
                        Dúvida aberta por: {{ doubt.userName }}
                    </p>
                </div>
                <div class="status-wrapper">
                    <span
                        class="status"
                        :class="{
                            'not-answered': doubt.status === 0,
                            'answered': doubt.status === 1,
                        }"
                    >
                        {{ getStatusText(doubt.status) }}
                    </span>
                    <span class="date"
                        >Criada em: {{ formatDate(doubt.dateInsert) }}</span
                    >
                </div>
            </div>

            <div>
                <!-- <div class="meta-info">
                <span class="course">Curso: {{ courseName }}</span>
              </div> -->

                <div class="chat-container">
                    <div class="chat-messages" ref="chatMessages">
                        <div v-if="messages.length">
                            <div
                                v-for="(message, index) in messages"
                                :key="message.id || index"
                                :class="[
                                    'message',
                                    index % 2 === 0 ? 'student' : 'teacher'
                                ]"
                            >
                                <div class="message-header">
                                    <div class="user-info">
                                        <img
                                            :src="
                                                message.userFinalPhoto ||
                                                '/default-avatar.png'
                                            "
                                            class="avatar"
                                        />
                                        <span class="name">{{
                                            message.userName
                                        }}</span>
                                    </div>
                                    <span class="time">{{
                                        formatDate(message.dateInsert)
                                    }}</span>
                                </div>
                                <div class="message-body" v-html="message.message">
                                    
                                </div>
                            </div>
                        </div>
                        <div v-else class="no-messages">
                            <i class="far fa-comments"></i>
                            <p>Nenhuma mensagem encontrada</p>
                        </div>
                    </div>

                    <div class="chat-input" v-if="doubt.status !== 3">
                        <textarea
                        class="inputd"
                            v-model="newReply"
                            placeholder="Digite sua resposta..."
                            rows="3"
                            :disabled="loading"
                        ></textarea>

                        <button
                            class="btn-weflix primary"
                            @click="sendReply"
                            :disabled="loading || !newReply.trim()"
                        >
                            <fa icon="fas fa-paper-plane"></fa>
                            {{ loading ? 'Enviando...' : 'Enviar' }}
                        </button>
                    </div>
                    <div v-else class="chat-closed">
                        <i class="fas fa-lock"></i>
                        <p>Esta dúvida foi deletada</p>
                    </div>
                </div>

                <!-- <div class="button-container" v-if="isActive">
              <button 
                class="btn-weflix"
                @click="closeDoubt"
                :disabled="loading"
              >
                <i class="fas fa-check-circle"></i>
                Fechar Dúvida
              </button>
            </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import ApiInquiryMessage from '@/utils/mensage';
    import { toast } from 'vue3-toastify';

    export default {
        data() {
            return {
                doubtId: this.$route.params.slug,
                messages: [],
                newReply: '',
                loading: true,
                isActive: true,
                doubt: {
                    idInquiry: '',
                    idMessage: null,
                    idUser: '',
                    title: '',
                    description: null,
                    status: 0,
                    dateInsert: '',
                    userName: '',
                },
            };
        },
        computed: {
            ...mapState(['token', 'doubt']),
        },
        methods: {
            getStatusText(status) {
                switch (status) {
                    case 0:
                        return 'Não Respondida';
                    case 1:
                        return 'Respondida';
                    case 3:
                        return 'Deletada';
                    default:
                        return 'Status Desconhecido';
                }
            },
            async getMessages() {
                this.loading = true;
                const id = this.$route.params.slug;
                try {
                    const response =
                        await ApiInquiryMessage.getDataMensageByInquiryId(
                            this.token,
                            id
                        );
                    this.messages = response.messages;
                    this.doubt = response.inquiry;
                } catch (error) {
                    toast.error('Erro ao carregar mensagens. Por favor, tente novamente.');
                    console.error('Erro ao carregar mensagens:', error);
                } finally {
                    this.loading = false;
                }
            },
            async sendReply() {
                if (!this.newReply.trim()) return;

                try {
                    const payload = {
                        message: this.newReply,
                    };

                    const response = await ApiInquiryMessage.createNewMessage(
                        payload,
                        this.doubtId,
                        this.token
                    );

                    if (response) {
                        // Adiciona apenas a nova mensagem ao array
                        this.messages.push({
                            message: this.newReply,
                            dateInsert: new Date(),
                            idUser: this.doubt.idTeacher,
                            userName: 'Professor', // Ajuste conforme necessário
                            userFinalPhoto: null, // Ajuste conforme necessário
                        });

                        this.newReply = '';
                        this.scrollToBottom();
                    }
                } catch (error) {
                    toast.error('Erro ao enviar resposta. Por favor, tente novamente.');
                    console.error('Erro ao enviar resposta:', error);
                }
            },
            async closeDoubt() {
                if (!confirm('Tem certeza que deseja fechar esta dúvida?'))
                    return;

                this.loading = true;
                try {
                    // Implementar chamada API para fechar dúvida
                    this.isActive = false;
                } catch (error) {
                    console.error('Erro ao fechar dúvida:', error);
                } finally {
                    this.loading = false;
                }
            },
            formatDate(date) {
                return new Date(date).toLocaleString();
            },
            scrollToBottom() {
                setTimeout(() => {
                    const container = this.$refs.chatMessages;
                    container.scrollTop = container.scrollHeight;
                }, 100);
            },
        },
        created() {
            this.getMessages();
        },
    };
</script>

<style scoped>
   .doubts-container.weeducAdminDoubt svg.svg-inline--fa.fa-paper-plane {
    color: white;
}

.doubts-container.weeducAdminDoubt .content.dashboard >  {
    padding-bottom: 0;
}
.doubts-container.weeducAdminDoubt {
    max-width: 100%;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    margin: 0 auto;
}

.doubts-container.weeducAdminDoubt .loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
}

.doubts-container.weeducAdminDoubt .loader {
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    border-top: 4px solid #2f2e8b;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.doubts-container.weeducAdminDoubt .title-container {
    position: relative;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.doubts-container.weeducAdminDoubt .title-wrapper {
    flex: 1;
}

.doubts-container.weeducAdminDoubt .status-wrapper {
    display: block;
}

.doubts-container.weeducAdminDoubt .form-container {
    padding: 0 1.5rem;
}

.doubts-container.weeducAdminDoubt .form-group {
    margin-bottom: 1.5rem;
    width: 100%;
}

.doubts-container.weeducAdminDoubt .form-row {
    display: flex;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
    align-items: flex-start;
}

.doubts-container.weeducAdminDoubt .meta-info {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
    align-items: center;
}

.doubts-container.weeducAdminDoubt .status {
    padding: 0.625rem 1.25rem;
    border-radius: 50px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #ffffff;
}

.doubts-container.weeducAdminDoubt .status.answered {
    background-color: green;
}

.doubts-container.weeducAdminDoubt .status.not-answered {
    background-color: #e8e8e8;
    color: #5c5c5c;
}

.doubts-container.weeducAdminDoubt .chat-container {
    background: rgb(var(--v-theme-cardBackground));
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    margin-bottom: 1.5rem;
}

.doubts-container.weeducAdminDoubt .chat-messages {
    height: 54vh;
    overflow-y: auto;
    padding: 2rem;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e0 #f7fafc;
}

.doubts-container.weeducAdminDoubt .chat-messages::-webkit-scrollbar {
    width: 6px;
}

.doubts-container.weeducAdminDoubt .chat-messages::-webkit-scrollbar-track {
    background: #f7fafc;
}

.doubts-container.weeducAdminDoubt .chat-messages::-webkit-scrollbar-thumb {
    background-color: #cbd5e0;
    border-radius: 3px;
}

.doubts-container.weeducAdminDoubt .message {
    margin-bottom: 1rem;
    animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.doubts-container.weeducAdminDoubt .message.student {
    margin-right: auto;
}

.doubts-container.weeducAdminDoubt .message.teacher {
    margin-left: auto;
}

.doubts-container.weeducAdminDoubt .message-header {
    margin-bottom: 0.75rem;
   
}

.doubts-container.weeducAdminDoubt .user-info {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.doubts-container.weeducAdminDoubt .avatar {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #e5e7eb;
}

.doubts-container.weeducAdminDoubt .name {
    font-weight: 600;
    color: #1f2937;
    font-size: 1rem;
}

.doubts-container.weeducAdminDoubt .time {
    font-size: 0.875rem;
    color: #6b7280;
}

.doubts-container.weeducAdminDoubt .message-body {
    padding: 1.25rem;
    border-radius: 12px;
    line-height: 1.6;
    font-size: 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.doubts-container.weeducAdminDoubt .message.student .message-body,
.doubts-container.weeducAdminDoubt .message.teacher .message-body {
    background: rgb(var(--v-theme-fieldBackground));
    color: rgb(var(--v-theme-text));
}

.doubts-container.weeducAdminDoubt .chat-input {
    padding: 1.5rem;
    border-top: 2px solid #e5e7eb;
    background: rgb(var(--v-theme-background));
    display: flex;
    justify-content: space-between;
    align-items: self-end;
    gap: 10px;
}

.doubts-container.weeducAdminDoubt textarea {
    width: 100%;
    padding: 1rem;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
    margin-bottom: 0;
    resize: vertical;
    min-height: 100px;
}

.doubts-container.weeducAdminDoubt textarea:focus {
    outline: none;
    border-color: #2f2e8b;
    box-shadow: 0 0 0 3px rgba(47, 46, 139, 0.1);
}

.doubts-container.weeducAdminDoubt .btn-weflix {
    padding: 0.75rem 1.5rem;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    background: white;
    color: #4a5568;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    font-weight: 600;
    font-size: 1rem;
}

.doubts-container.weeducAdminDoubt .btn-weflix.primary {
    background: #2f2e8b;
    color: white;
    border: none;
}

.doubts-container.weeducAdminDoubt .btn-weflix:hover:not(:disabled) {
    background: #23225f;
    transform: translateY(-1px);
}

.doubts-container.weeducAdminDoubt .btn-weflix:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.doubts-container.weeducAdminDoubt .button-container {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
}

.doubts-container.weeducAdminDoubt .no-messages,
.doubts-container.weeducAdminDoubt .chat-closed {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    color: #6b7280;
    text-align: center;
}

.doubts-container.weeducAdminDoubt .no-messages i,
.doubts-container.weeducAdminDoubt .chat-closed i {
    font-size: 3.5rem;
    margin-bottom: 1.5rem;
    opacity: 0.6;
}

@media (max-width: 768px) {
    .doubts-container.weeducAdminDoubt {
        padding: 1rem;
    }

    .doubts-container.weeducAdminDoubt .form-container {
        padding: 0 1rem;
    }

    .doubts-container.weeducAdminDoubt .meta-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .doubts-container.weeducAdminDoubt .message {
        max-width: 90%;
    }

    .doubts-container.weeducAdminDoubt .chat-messages {
        height: 50vh;
        padding: 1rem;
    }

    .doubts-container.weeducAdminDoubt .button-container {
        flex-direction: column;
        gap: 0.75rem;
    }
    .doubts-container.weeducAdminDoubt .chat-input {
        flex-direction: column;
    }
}

.doubts-container.weeducAdminDoubt .course {
    height: auto;
}
/* DARK */
.dashboard.dark .doubts-container.weeducAdminDoubt .no-messages,
.dashboard.dark .doubts-container.weeducAdminDoubt .chat-closed {
    color: white;
}

.dashboard.dark .doubts-container.weeducAdminDoubt span.date {
    color: white;
}
.dashboard.dark .doubts-container.weeducAdminDoubt .user-info .name {
    color: white;
}
.dashboard.dark .doubts-container.weeducAdminDoubt .time {
    color: white;
}

.doubts-container.weeducAdminDoubt .user-info img.avatar {
    width: 40px;
    height: 40px;
}
.doubts-container.weeducAdminDoubt .message.student .message-body {
    text-align: left;
}
.doubts-container.weeducAdminDoubt .message.teacher .message-header {
    justify-content: flex-end;
}
.doubts-container.weeducAdminDoubt .message.teacher .message-body{
    text-align: right;
}
.doubts-container.weeducAdminDoubt .message.student .message-header {
    justify-content: flex-start;
}
.doubts-container.weeducAdminDoubt .message.student .message-body{
    text-align: left;
}
.doubts-container.weeducAdminDoubt .message.student .message-header {
    text-align: left;
}
.doubts-container.weeducAdminDoubt .message.teacher .message-header {
    text-align: right;
}
.doubts-container.weeducAdminDoubt .message.teacher .user-info{
    justify-content: flex-end;
}

.doubts-container.weeducAdminDoubt .title-container .status {
    font-size: 13px;
    padding: 2px 10px;
    border-radius: 8px;
    background: #e6f4ea;
    color: #3f3f3f;
    font-weight: 500;
}
</style>
